const api = process.env.REACT_APP_API_URL;

/**
 * The GROQ queries live in the sanity-api-proxy repo, not here. The client only
 * names a query and binds values to it — it cannot send a query of its own.
 */
function fetchQuery(queryId, params) {
  const search = `?queryId=${encodeURIComponent(queryId)}`;
  const paramsSearch = params ? `&params=${encodeURIComponent(JSON.stringify(params))}` : '';

  return fetch(`${api}${search}${paramsSearch}`).then((payload) => {
    if (!payload.ok) throw new Error(`Sanity proxy responded ${payload.status}`);
    return payload.json();
  });
}

export function sanity_categories() {
  return fetchQuery('categories');
}

export function sanity_all_categories() {
  return fetchQuery('allCategories');
}

export function sanity_articleById(id) {
  return fetchQuery('articleById', { id });
}

export function sanity_articleByPathname(pathname) {
  return fetchQuery('articleByPathname', { pathname });
}

export function sanity_articleByCategoryPathname(pathname) {
  return fetchQuery('articleByCategoryPathname', { pathname });
}
